import { ConversationContactStatusEnum } from '@/enums/crm/conversation-contact-status.enum';

export default class ConversationContactModel {
  waId!: string;

  input!: string;

  status!: ConversationContactStatusEnum;
}
